import PropTypes from 'prop-types';
// next
import NextLink from 'next/link';
// @mui
import { Card, CardContent, Link, Stack, Typography } from '@mui/material';
// routes
import { PATH_RESOURCE } from '../../../routes/paths';
// hooks
// utils
import { fShortenNumber } from '../../../utils/formatNumber';
// components
import Iconify from '../../../components/Iconify';
import Image from '../../../components/Image';
import TextIconLabel from '../../../components/TextIconLabel';
import TextMaxLine from '../../../components/TextMaxLine';
import useLocales from '../../../hooks/useLocales';
import { fToNow, parseDateTimeSuffix } from '../../../utils/formatTime';

// ----------------------------------------------------------------------

BlogPostCard.propTypes = {
  post: PropTypes.object.isRequired,
  index: PropTypes.number,
};

export default function BlogPostCard({ post, index }) {
  const { slug, title, featureImage, statistic, createdAt, createdBy } = post;
  const linkTo = `${PATH_RESOURCE.blogs}/${slug}`;

  return (
    <Card>
      <NextLink href={linkTo} passHref>
        <Link>
          <Image alt="cover" src={featureImage} ratio="16/9" />
        </Link>
      </NextLink>
      <PostContent title={title} view={statistic.viewNo} comment={statistic.commentNo} like={statistic.likeNo} createdAt={createdAt} index={index} slug={slug} />
    </Card>
  );
}

// ----------------------------------------------------------------------

PostContent.propTypes = {
  comment: PropTypes.number,
  createdAt: PropTypes.string,
  index: PropTypes.number,
  like: PropTypes.number,
  title: PropTypes.string,
  view: PropTypes.number,
  slug: PropTypes.string,
};

export function PostContent({ title, view, comment, like, createdAt, slug }) {
  const { currentLang } = useLocales();

  const linkTo = `${PATH_RESOURCE.blogs}/${slug}`;

  const POST_INFO = [
    { number: comment, icon: 'eva:message-circle-fill' },
    { number: view, icon: 'mdi:eye' },
    { number: like, icon: 'mdi:like' },
  ];

  return (
    <CardContent
      sx={{
        pt: 1,
        width: 1
      }}
    >
      <Typography
        gutterBottom
        variant="caption"
        component="div"
        sx={{
          color: 'text.disabled',
        }}
      >
        {fToNow(parseDateTimeSuffix(createdAt), currentLang.value)}
      </Typography>

      <NextLink href={linkTo} passHref>
        <Link color="inherit">
          <TextMaxLine variant={'subtitle1'} line={1} persistent>
            {title}
          </TextMaxLine>
        </Link>
      </NextLink>

      <Stack
        flexWrap="wrap"
        direction="row"
        justifyContent="flex-start"
        sx={{
          mt: 1,
          color: 'text.disabled',
        }}
      >
        {POST_INFO.map((info, index) => (
          <TextIconLabel
            key={index}
            icon={<Iconify icon={info.icon} sx={{ width: 15, height: 15, mr: 0.5 }} />}
            value={fShortenNumber(info.number)}
            sx={{ typography: 'caption', ml: index === 0 ? 0 : 1.5 }}
          />
        ))}
      </Stack>
    </CardContent>
  );
}
